<template>
  <div id="main_content" class="iw-layout-grid page-wrapper-grid" :class="{ 'remove-margin-top': removeMarginTop }" role="main">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "AppPageWrapperGrid",
  props: {
    removeMarginTop: Boolean
  }
};
</script>

<style scoped lang="scss">
.page-wrapper-grid {
  tab-index: 0;
  min-height: calc(100vh - #{($headerDesktopHeight + $footer-height)});
  margin-top: $headerDesktopHeight;

  @include respond-to-mobile {
    min-height: calc(100vh - #{($headerMobileHeight + $footer-height)});
    margin-top: $headerMobileHeight;
  }
}
.remove-margin-top {
  margin-top: 0;
}
</style>
